<template>
  <div>
    <h1 class="page-title">{{ $t("NewUser.title") }}</h1>
    <div class="card card-transparent">
      <div class="card-block">
        <user-form :isManager="false" :entityId="entityId" :collapseHubs="true" />
      </div>
    </div>
  </div>
</template>

<script>
import UserForm from './UserForm'

export default {
  name: 'NewUser',
  components: { UserForm },
  computed: {
    entityId(){
      if (this.$route) {
        return parseInt(this.$route.params.entity_id);
      }
    },
  },
  mounted: function(){
    this.$store.dispatch('users/reset');
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/NewUser.vue